module.exports = require("./ln-CG.js");